import styled from 'styled-components/macro';

import { sizes } from '../../styles/vars';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;

  word-break: break-word;
  overflow-wrap: break-word;

  & .imageBlock {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-basis: 35%;
    padding: ${sizes.blockPaddingX};
    padding-left: 0;

    & .image {
      width: 130px;
      max-height: 169px;
      border-radius: 2px;
    }
  }
`;

export default Wrapper;
